<iframe id="panoFrame" class="externalSceneContainer" [src]="iframeSrc | safe" (load)="panoFrameLoaded()" title="Pano Frame"></iframe>
<div class="navigatorContainer">
  @if (showNavigator) {
    <ins-navigator [style.visibility]="navigatorVisible" [style.pointerEvents]="navigatorVisible === 'hidden' ? 'none' : 'auto'"></ins-navigator>
  }
</div>